import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class EventConfigurationStatusesService {

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}event-configurations/statuses`).then((data) => {
        resolve({ statuses: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default EventConfigurationStatusesService;
